import { useState } from 'react'
import dashboardApi from 'services/api/dashboard'

export const NO_ORGANIZATION_MESSAGE =
  'No matching Pipedrive organization found. Confirm CSM Details → Dashboard ID - ORG.'

export const OPEN_FAILED_MESSAGE = 'Failed to open Pipedrive organization'

export function readOrganizationUrl(result) {
  return result?.organizationUrl || result?.OrganizationUrl || null
}

/**
 * Resolves the Pipedrive organization of a hotel by its dashboard display ID
 * and opens it in a new tab.
 *
 * @param {String|Number} displayId
 */
function usePipedriveOrganization(displayId) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)

  const openOrganization = async () => {
    if (!displayId || isLoading) {
      return
    }

    setIsLoading(true)
    setError(null)

    try {
      const result = await dashboardApi.resolveBillingPipedriveOrganization(displayId)
      const organizationUrl = readOrganizationUrl(result)

      if (!organizationUrl) {
        throw new Error(NO_ORGANIZATION_MESSAGE)
      }

      window.open(organizationUrl, '_blank', 'noopener,noreferrer')
    } catch (err) {
      setError(err.message || OPEN_FAILED_MESSAGE)
    } finally {
      setIsLoading(false)
    }
  }

  return { isLoading, error, openOrganization }
}

export default usePipedriveOrganization
